<script setup lang="ts">
import { computed } from "vue";
import type { Pull, MeterRow } from "../lib/types";

const props = defineProps<{ pull: Pull }>();

const damage = computed(() => props.pull.damage.slice(0, 10));
const healing = computed(() => props.pull.healing.slice(0, 10));

function fmt(n: number) {
  if (n >= 1e9) return (n / 1e9).toFixed(1) + "B";
  if (n >= 1e6) return (n / 1e6).toFixed(1) + "M";
  if (n >= 1e3) return (n / 1e3).toFixed(0) + "K";
  return String(n);
}
function pct(rows: MeterRow[], v: number) {
  const max = rows[0]?.total || 1;
  return (v / max) * 100;
}
</script>

<template>
  <section class="space-y-5 text-sm">
    <div>
      <h2 class="mb-2 text-xs font-semibold uppercase tracking-wide text-zinc-500">Damage</h2>
      <ul class="space-y-1">
        <li
          v-for="r in damage"
          :key="r.name"
          class="relative overflow-hidden rounded bg-zinc-900"
        >
          <div
            class="absolute inset-y-0 left-0 bg-red-500/20"
            :style="{ width: pct(damage, r.total) + '%' }"
          ></div>
          <div class="relative flex justify-between px-2 py-1">
            <span class="truncate">{{ r.name }}</span>
            <span class="ml-2 font-mono text-zinc-400">{{ fmt(r.total) }}</span>
          </div>
        </li>
      </ul>
    </div>

    <div>
      <h2 class="mb-2 text-xs font-semibold uppercase tracking-wide text-zinc-500">Healing</h2>
      <ul class="space-y-1">
        <li
          v-for="r in healing"
          :key="r.name"
          class="relative overflow-hidden rounded bg-zinc-900"
        >
          <div
            class="absolute inset-y-0 left-0 bg-emerald-500/20"
            :style="{ width: pct(healing, r.total) + '%' }"
          ></div>
          <div class="relative flex justify-between px-2 py-1">
            <span class="truncate">{{ r.name }}</span>
            <span class="ml-2 font-mono text-zinc-400">{{ fmt(r.total) }}</span>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>
